
export default {
  name: "PinSvg",
};
